import { faDesktop } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useContext } from "react";
import { Mobile, Tablet } from "../../../assets/ui-icons";
import { GrigoraEditorContext } from "../context";
import { motion } from "framer-motion";
import { Tooltip } from "../../input";

function Devices() {
  const {
    project,
    publishProject,
    isPublishing,
    leftWidget,
    setLeftWidget,
    updatePages,
    pagesData,
    currentPage,
    displaySize,
    setDisplaySize,
    routerState,
    projectComponents,
  } = useContext(GrigoraEditorContext);

  return (
    <div
      id="devices"
      className="devices-container flex text-gray-700 mr-6 bg-gray-100 rounded-[6px] gap-1 items-center h-fit my-auto p-[1px]"
    >
      <Tooltip mouseEnterDelay={0.5} text="Desktop View" placement="bottom">
        <div
          onClick={(e) => {
            setDisplaySize("desktop");
          }}
          style={
            {
              // color: displaySize === "desktop" ? "black" : undefined,
            }
          }
          className="device-wrapper"
        >
          {displaySize === "desktop" && (
            <motion.div
              layoutId="device-switch-bg"
              className="device-switch-wrapper"
            ></motion.div>
          )}
          <FontAwesomeIcon
            icon={faDesktop}
            size="xs"
            className="relative z-10"
          />
        </div>
      </Tooltip>
      <Tooltip mouseEnterDelay={0.5} text="Tablet View" placement="bottom">
        <div
          onClick={(e) => {
            setDisplaySize("tablet");
          }}
          style={
            {
              // color: displaySize === "tablet" ? "black" : undefined,
            }
          }
          className="device-wrapper"
        >
          {displaySize === "tablet" && (
            <motion.div
              layoutId="device-switch-bg"
              className="device-switch-wrapper"
            ></motion.div>
          )}
          <Tablet className="w-[20px] h-[20px] relative z-10" />
        </div>
      </Tooltip>
      <Tooltip mouseEnterDelay={0.5} text="Mobile View" placement="bottom">
        <div
          onClick={(e) => {
            setDisplaySize("mobile");
          }}
          style={
            {
              // color: displaySize === "mobile" ? "black" : undefined,
            }
          }
          className="device-wrapper"
        >
          {displaySize === "mobile" && (
            <motion.div
              layoutId="device-switch-bg"
              className="device-switch-wrapper"
            ></motion.div>
          )}
          <Mobile className="w-[20px] h-[20px] relative z-10" />
        </div>
      </Tooltip>
    </div>
  );
}

export default Devices;
